import React, { useState } from "react";
import { getApartment } from "./API/queries";
import { useQuery } from "react-query";
import singleApartment from "./models/singleApartment";
import ReservationModal from "./Components/Reservation/ReservationModal";
import "./styles.css";

function FormApp() {
  const { isLoading, error, data } = useQuery(
    ["apartment", window.pdxApartment.key],
    getApartment
  );
  const [modalOpen, setModalOpen] = useState(false);

  if (isLoading) {
    return (
      <div className="my-2 mr-2">
        <button
          disabled={true}
          className="px-3 py-1 rounded-pill font-bold text-black h-42px bg-laptigray-light text-md font-effra focus:outline-none"
        >
          {"Ladataan tietoja..."}
        </button>
      </div>
    );
  }
  const apartment = singleApartment(data);
  return (
    <div className="mr-2">
      <button
        onClick={() => {
          setModalOpen(true);
        }}
        className="px-3 my-2 py-1 rounded-pill font-bold text-white h-42px bg-laptiorange text-md font-effra focus:outline-none"
      >
        {apartment.available ? "Varaa asunto" : "Liity jonoon"}
      </button>
      <ReservationModal
        open={modalOpen}
        apartment={apartment}
        closeModal={() => {
          setModalOpen(false);
        }}
      />
    </div>
  );
}

export default FormApp;
